//
//
//
//
//
//
//
//
//
//
//
//

import PersonalDetailsStep from "./steps/personal-details-step.vue";
import VerifiedStep from "./steps/verified-step.vue";
import VerifyStep from "./steps/verify-step.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "RegistrationSteps",
  components: {
    PersonalDetailsStep,
    VerifyStep
  },
  props: {
    currentPage: {
      type: String,
      required: true
    },
    loadingState: {
      type: Object,
      required: true
    }
  },
  computed: {
    componentMap() {
      return {
        "personal-details": PersonalDetailsStep,
        verify: VerifyStep,
        complete: VerifiedStep
      };
    },
    currentComponent() {
      return this.componentMap[this.currentPage];
    }
  },
  methods: {
    handleAccountCreate(accountDetails) {
      this.$emit("create", accountDetails);
    },
    handleVerifyAccount(accountDetails) {
      this.$emit("verify", accountDetails);
    },
    handleResendCode(accountDetails) {
      this.$emit("resend-code", accountDetails);
    }
  }
});